<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{ isUpdateMode ? ('MENU.DISHES.EDIT.EDIT_DISH' | translate) : ('MENU.WAS_ADD_DISH' | translate) }}
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="dish">
      <div class="dish-data">
        <div class="dish-data-title">
          <div class="dish-data-title-names">
            <mat-form-field class="dish-name" appearance="fill">
              <mat-label>{{ 'MENU.DISHES.NEW.NAME' | translate }}</mat-label>
              <input matInput type="text" formControlName="dishName" [class.isDifferent]="isProductNameDifferent()"
                     (input)="updateChangesInformationMessage()">
              <mat-icon *ngIf="isProductNameDifferent()" matSuffix mat-icon-button aria-label="Clear"
                        class="restore"
                        matTooltip="{{data.originalProduct?.name}}" (click)="clearProductName()">restore
              </mat-icon>
            </mat-form-field>
            <div *ngIf="data.organization.additionalLanguages">
              <mat-form-field class="dish-name" appearance="fill"
                              *ngFor="let lang of data.organization.additionalLanguages">
                <mat-label>{{ 'MENU.DISHES.NEW.NAME' | translate }} {{ lang }}</mat-label>
                <input matInput formControlName="productName{{lang}}"
                       [class.isDifferent]="isProductNameTranslationDifferent(lang)"
                       (input)="updateChangesInformationMessage()">
                <mat-icon *ngIf="isProductNameTranslationDifferent(lang)" matSuffix mat-icon-button aria-label="Clear"
                          class="restore"
                          matTooltip="{{getOriginalNameTranslation(lang)}}" (click)="clearProductNameTranslation(lang)">
                  restore
                </mat-icon>
              </mat-form-field>
            </div>
          </div>
          <app-select-image-field
            [image]="selectedDishImgSrc"
            [overrideUrl]="overrideDishImgSrc"
            [originalUrl]="data.originalProduct.externalPictureUrl"
            [organizationId]="data.organizationId"
            (imageChanged)="data.allowOverrides && onImageChanged($event)"
            [allowOverrides]="data.allowOverrides"
          ></app-select-image-field>
        </div>

        <div>
          <mat-form-field class="dish-price" appearance="fill">
            <mat-label>{{ 'MENU.DISHES.NEW.PRICE' | translate }}</mat-label>
            <input matInput #dishPrice type="number" placeholder="00.00" formControlName="dishPrice"
                   min="0" [class.isDifferent]="isProductPriceDifferent()" (input)="updateChangesInformationMessage()">
            <mat-icon *ngIf="isProductPriceDifferent()" matSuffix mat-icon-button aria-label="Clear"
                      class="restore"
                      matTooltip="{{getOriginalProductPrice()}}" (click)="clearProductPrice()">
              restore
            </mat-icon>
          </mat-form-field>
          <span class="dish-currency">{{ currency }}</span>
        </div>
        <div *ngIf="!hasPrice">
          <h3>{{ 'MENU.DISHES.SIZES' | translate }}</h3>

          <div *ngIf="data.originalProduct?.productStructure">
            <mat-label [class.isDifferent]="isSizeScaleDifferent()">{{ 'MENU.SELECT_SIZE_SCALE' | translate }}
            </mat-label>
            <div>
              <mat-form-field>
                <mat-select [(value)]="form.value['sizeScaleId']" formControlName="sizeScaleId"
                            (input)="updateChangesInformationMessage()">
                  <mat-option [value]="null">No size scale</mat-option>
                  <mat-option *ngFor="let sizeScale of sizeScales" [value]="sizeScale.id">{{ sizeScale.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon
                mat-icon-button
                matTooltip="{{'MENU.SIZE_SCALES.CREATE' | translate}}"
                class="size-scale-edit-button"
                (click)="openEditSizeScaleModal()">add_box
              </mat-icon>
              <mat-icon
                *ngIf="form.value['sizeScaleId']"
                mat-icon-button
                matTooltip="{{'MENU.SIZE_SCALES.EDIT' | translate}}"
                class="size-scale-edit-button"
                (click)="openEditSizeScaleModal(form.value['sizeScaleId'])">edit
              </mat-icon>
              <mat-icon
                *ngIf="form.value['sizeScaleId']"
                mat-icon-button
                matTooltip="{{'MENU.SIZE_SCALES.EDIT' | translate}}"
                class="size-scale-edit-button"
                (click)="openDeleteSizeScaleDialog()">delete
              </mat-icon>
            </div>
          </div>

          <div>
            <mat-checkbox matInput class="example-margin" formControlName="isShowHideSizes"
                          (change)="toggleShowHideSizes($event)">
              <label>{{ 'MENU.SHOW_HIDE_SIZES' | translate }}</label>
            </mat-checkbox>
          </div>
          <div *ngIf="data.product.productStructure">
            <mat-checkbox matInput class="example-margin" formControlName="hideSizesImages"
                          (change)="toggleHideSizesImages($event)">
              <label [class.isDifferent]="this.hideSizesImages">{{ 'MENU.HIDE_SIZES_IMAGES' | translate }}</label>
            </mat-checkbox>
          </div>

          <div class="size-structure"
               [class.hidden-size]="size.isHidden"
               *ngFor="let size of sizes">
            <div>
              <mat-label style="margin: auto 5px">{{ 'MENU.SIZES.HIDE' | translate }}</mat-label>
              <mat-checkbox formControlName="isHidden{{size.sizeId}}" (change)="updateChangesInformationMessage()">
              </mat-checkbox>
              <mat-label style="margin: auto 5px">{{ 'MENU.DEFAULT' | translate }}</mat-label>
              <mat-checkbox #defaultSizeCheckbox checked="{{size.sizeId === defaultSizeId}}" (change)="changeDefaultSizeId(size.sizeId, $event)">
              </mat-checkbox>
              <mat-icon *ngIf="isDefaultSizeDifferent(size.sizeId, defaultSizeCheckbox)" matSuffix mat-icon-button aria-label="Clear"
                        class="restore"
                        (click)="clearDefaultSizeId()">restore
              </mat-icon>
              <br>
              <span
                (click)="editSize(size.sizeId)"
                [ngClass]="{'size-name': true, 'isDifferent': isChangedSize(size.sizeId)}"
              >
                {{ getSizeName(size.sizeId) }}
              </span>
              <mat-form-field class="dish-price" appearance="fill">
                <mat-label>{{ 'MENU.DISHES.NEW.PRICE' | translate }}</mat-label>
                <input matInput type="number" placeholder="00.00" formControlName={{size.sizeId}}
                       min="0" [class.isDifferent]="isProductSizePriceDifferent(size.sizeId)"
                       (input)="updateChangesInformationMessage()">
                <mat-icon *ngIf="isProductSizePriceDifferent(size.sizeId)" matSuffix mat-icon-button aria-label="Clear"
                          class="restore"
                          matTooltip="{{getOriginalSizePrice(size.sizeId)}}"
                          (click)="clearProductSizePrice(size.sizeId)">restore
                </mat-icon>
              </mat-form-field>
              <span class="dish-currency">{{ currency }}</span>
              <mat-form-field class="dish-weight" appearance="fill">
                <mat-label>{{ 'MENU.WEIGHT' | translate }}</mat-label>
                <input matInput type="number" placeholder="00.00" formControlName="{{size.sizeId}}weight"
                       min="0" [class.isDifferent]="isProductSizeWeightDifferent(size.sizeId)"
                       (input)="updateChangesInformationMessage()">
                <mat-icon *ngIf="isProductSizeWeightDifferent(size.sizeId)" matSuffix mat-icon-button aria-label="Clear"
                          class="restore"
                          matTooltip="{{getOriginalSizeWeight(size.sizeId)}}"
                          (click)="clearProductSizeWeight(size.sizeId)">restore
                </mat-icon>
              </mat-form-field>
            </div>
            <div class="size-image" *ngIf="viewInit" [hidden]="hideSizesImages">
              <!--              image of size-->
              <app-select-image-field
                [image]="size?.externalPictureUrl"
                [overrideUrl]="size.externalPictureUrl"
                [originalUrl]="getOriginalSize(size.sizeId).externalPictureUrl"
                [organizationId]="data.organizationId"
                [inputImgDefaultSrc]="'assets/images/dishes/logo-small.png'"
                (imageChanged)="data.allowOverrides && onSizeImageChanged($event, size.sizeId)"
                [allowOverrides]="data.allowOverrides"
                style="height: 70px;"
              ></app-select-image-field>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="media-info">
      <div class="media-info-title">{{ 'MENU.MEDIA_INFO' | translate }}</div>

      <div class="media-info-row">
        <div class="media-info-content">
          <div>{{ 'MENU.MENU_MEDIA' | translate }}</div>
          <app-select-video-field
            [video]="data.product.mediaInfo?.menuMediaUrl"
            [overrideUrl]="data.product.mediaInfo?.menuMediaUrl"
            [organizationId]="data.organizationId"
            [allowOverrides]="data.allowOverrides"
            (videoChanged)="data.allowOverrides && onVideoChanged($event, 'menuMediaUrl')"
          >
          </app-select-video-field>
        </div>

        <div class="media-info-content">
          <div>{{ 'MENU.CARD_MEDIA' | translate }}</div>
          <app-select-video-field
            [video]="data.product.mediaInfo?.cardMediaUrl"
            [overrideUrl]="data.product.mediaInfo?.cardMediaUrl"
            [organizationId]="data.organizationId"
            [allowOverrides]="data.allowOverrides"
            (videoChanged)="data.allowOverrides && onVideoChanged($event, 'cardMediaUrl')"
          >
          </app-select-video-field>
        </div>
      </div>
    </div>

    <div class="weight">
      <div class="new-dish-label weight-label">
        SKU
      </div>
      <mat-form-field class="weight-form-field" appearance="fill">
        <input matInput class="weight-input" disabled placeholder="no info" [value]="data.product.sku">
      </mat-form-field>
    </div>

    <div class="weight">
      <div class="new-dish-label weight-label">
        {{ 'MENU.DISHES.NEW.WEIGHT' | translate }}
      </div>
      <mat-form-field class="weight-form-field" appearance="fill">
        <input matInput class="weight-input" type="number" placeholder="0" formControlName="weight"
               min="0" [class.isDifferent]="isProductWeightDifferent()" (input)="updateChangesInformationMessage()">
        <mat-icon *ngIf="isProductWeightDifferent()" matSuffix mat-icon-button aria-label="Clear"
                  class="restore"
                  matTooltip="{{data.originalProduct.weight}}" (click)="clearProductWeight()">restore
        </mat-icon>
      </mat-form-field>
      <span class="weight-currency">{{ 'MENU.DISHES.NEW.WEIGHT_UNIT' | translate }}</span>
    </div>

    <app-tags-form-field-old
      [tags]="data.product.tags"
      [originalTags]="data.originalProduct.tags"
      (tagsChanged)="onTagsChanged($event)"
      (editModeChanged)="onEditModeChangedTags($event)"
      [allowOverrides]="data.allowOverrides"
    >
    </app-tags-form-field-old>

    <app-tags-form-field
      [tagIds]="data.product.tagIds"
      [organization]="data.organization"
      [menuSectionId]="data.menuSectionId"
      [menuId]="data.menuSections[0].menuId"
      (tagIdsChange)="onTagIdsChanged($event)"
      [allowOverrides]="data.allowOverrides"
    >
    </app-tags-form-field>

    <app-allergen-group
      *ngIf="data.product.productStructure"
      [allergenGroupIds]="data.product.productStructure?.allergenGroups"
      [organization]="data.organization"
      [menuSectionId]="data.menuSectionId"
      [menuId]="data.menuSections[0].menuId"
      (allergenGroupIdsChange)="onAllergenGroupIdsChange($event)"
      [allowOverrides]="data.allowOverrides"
    >
    </app-allergen-group>


    <!--RelatedProducts OLD-->
    <div class="description" *ngIf="showLegacyRelatedProducts">
      <div class="new-dish-label">
        {{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_NAME' | translate }}
      </div>
      <div class="description-right">
        <mat-form-field class="description-add-fields" appearance="fill">
          <mat-label>{{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_NAME' | translate }}</mat-label>
          <textarea matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                    formControlName="relatedProductsName"
                    class="description-textarea"
                    (input)="updateChangesInformationMessage()"
                    [class.isDifferent]="isRelatedProductsNameDifferent()"
          ></textarea>
          <mat-icon *ngIf="isRelatedProductsNameDifferent()" matSuffix mat-icon-button aria-label="Clear"
                    class="restore"
                    matTooltip="clear" (click)="clearRelatedProductsName()">restore
          </mat-icon>
        </mat-form-field>

        <!-- RelatedProducts translations -->
        <div *ngIf="data.organization.additionalLanguages">
          <div *ngFor="let lang of data.organization.additionalLanguages">
            <mat-form-field class="description-add-fields" appearance="fill">
              <mat-label>{{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_NAME' | translate }} {{ lang }}</mat-label>
              <textarea matInput
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        formControlName="relatedProductsName{{lang}}"
                        class="description-textarea"
                        (input)="updateChangesInformationMessage()"
                        [class.isDifferent]="isRelatedProductsNameTranslationsDifferent(lang)"
              ></textarea>
              <mat-icon *ngIf="isRelatedProductsNameTranslationsDifferent(lang)" matSuffix mat-icon-button
                        class="restore"
                        aria-label="Clear"
                        matTooltip="clear" (click)="clearRelatedProductsNameTranslations(lang)">restore
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showLegacyRelatedProducts">
      <div *ngIf="relatedProducts">
        Related products list:
        <div *ngFor="let relatedProduct of relatedProducts" [class.isDifferent]="isRelatedProductsDifferent()">
          <div>{{ products?.get(relatedProduct)?.name ?? relatedProduct }}</div>
        </div>
      </div>
      <mat-icon *ngIf="data.allowOverrides" (click)="editRelatedProducts()">edit</mat-icon>
      <mat-icon class="restore" (click)="restoreRelatedProducts()" *ngIf="data.allowOverrides && isRelatedProductsDifferent()">restore
      </mat-icon>
    </div>

    <!--Many RelatedProducts (NEW)-->
    <app-related-products
      [allowOverrides]="data.allowOverrides"
      [organization]="data.organization"
      [relatedProductInfos]="data.product.relatedProductsInfo ?? []"
      [subject]="data.product"
      [originalSubject]="data.originalProduct"
      [overridePosition]="overridePosition"
      [menuSectionId]="data.menuSectionId"
      [selectedMenuSections]="selectedMenuSections"
    >
    </app-related-products>

    <!--Many RelatedProducts Version 3-->
    <app-related-products-v3
      [allowOverrides]="data.allowOverrides"
      [organization]="data.organization"
      [product]="data.product"
      [originalProduct]="data.originalProduct"
      [overridePosition]="overridePosition"
      [menuSectionId]="data.menuSectionId"
      [selectedMenuSections]="selectedMenuSections"
      [menuId]="data.menuSections[0].menuId"
      (rpProgramIdsChange)="onRpProgramIdsChange($event)"
    >
    </app-related-products-v3>

    <!-- Description -->
    <div class="description">
      <div class="new-dish-label">
        {{ 'MENU.DISHES.NEW.DESCRIPTION' | translate }}
      </div>
      <div class="description-right">
        <mat-form-field class="description-add-fields" appearance="fill">
          <mat-label>{{ 'MENU.DISHES.NEW.DESCRIPTION' | translate }}</mat-label>
          <textarea matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                    formControlName="description"
                    class="description-textarea"
                    (input)="updateChangesInformationMessage()"
                    [class.isDifferent]="isProductDescriptionDifferent()"
          ></textarea>
          <mat-icon *ngIf="isProductDescriptionDifferent()" matSuffix mat-icon-button aria-label="Clear"
                    class="restore"
                    matTooltip="{{data.originalProduct?.description}}" (click)="clearProductDescription()">restore
          </mat-icon>
        </mat-form-field>

        <!-- Description translations -->
        <div *ngIf="data.organization.additionalLanguages">
          <div *ngFor="let lang of data.organization.additionalLanguages">
            <mat-form-field class="description-add-fields" appearance="fill">
              <mat-label>{{ 'MENU.DISHES.NEW.DESCRIPTION' | translate }} {{ lang }}</mat-label>
              <textarea matInput
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        formControlName="productDescription{{lang}}"
                        class="description-textarea"
                        (input)="updateChangesInformationMessage()"
                        [class.isDifferent]="isProductDescriptionTranslationDifferent(lang)"
              ></textarea>
              <mat-icon *ngIf="isProductDescriptionTranslationDifferent(lang)" matSuffix mat-icon-button
                        class="restore"
                        aria-label="Clear"
                        matTooltip="{{getOriginalDescriptionTranslation(lang)}}"
                        (click)="clearProductDescriptionTranslation(lang)">restore
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- Modifiers -->
    <div *ngIf="data?.product.productStructure && data?.product.productStructure.modifierGroups.length > 0">
      {{ 'MENU.MODIFIERS_DISPLAY_TYPE' | translate }}
      <div>
        <mat-form-field>
          <mat-select [(value)]="form.value['modifiersDisplayType']" formControlName="modifiersDisplayType"
                      (input)="updateChangesInformationMessage()">
            <mat-option *ngFor="let modifiersDisplayType of modifiersDisplayTypes" [value]="modifiersDisplayType">
              {{modifiersDisplayType}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="data?.product.productStructure && data?.product.productStructure.modifierGroups.length > 0"
         class="modifiers">
      <div class="new-dish-label">
        {{ 'MENU.DISHES.NEW.MODIFIERS' | translate }}
      </div>
      <div>
        <mat-accordion>
          <app-edit-modifier-group
            *ngFor="let modifierGroupStructure of sortModifierGroups(data?.product.productStructure.modifierGroups); trackBy: trackByFn; let i = index"
            [currency]="currency"
            [modifierGroupStructure]="modifierGroupStructure"
            [originalModifierGroupStructure]="getOriginalModifierGroupStructure(i)"
            [dictionaryModifierGroups]="dictionaryModifierGroups"
            [originalDictionaryModifierGroups]="originalDictionaryModifierGroups"
            [dictionaryProducts]="dictionaryProducts"
            [originalDictionaryProducts]="originalDictionaryProducts"
            [overridePositionsMap]="overridePositionsMap"
            [currentOrganization]="data.organization"
            [menuSections]="data.menuSections"
            [menuSectionId]="data.menuSectionId"
            [productId]="data.product.externalId"
            [saveForMenuSections]="getSavedMenuSections()"
            [saveForAll]="this.saveForAll"
            [saveForAllCombo]="this.saveForAllCombo"
            [saveForAllProductsInComboGroup]="this.data.saveForAllProductsInComboGroup"
            [comboGroupStructure]="this.data.comboGroupStructure"
            (changeInformationMessageEvent)="onChangeInformationMessage($event)"
            [allowOverrides]="data.allowOverrides"
          ></app-edit-modifier-group>
        </mat-accordion>
      </div>
    </div>

    <!-- Offer to collect combo (per-ComboStructure flag) -->
    <div *ngIf="data?.product.comboStructure && data?.product.comboStructure.groups.length > 0" class="combo-offer-to-collect">
      <mat-checkbox
        [(ngModel)]="offerToCollect"
        [ngModelOptions]="{standalone: true}"
        [disabled]="!data.allowOverrides">
        {{ 'MENU.OFFER_TO_COLLECT_COMBO' | translate }}
      </mat-checkbox>
    </div>

    <!-- Combo groups -->
    <div *ngIf="data?.product.comboStructure && data?.product.comboStructure.groups.length > 0" class="modifiers">
      <div class="new-dish-label">
        {{ 'MENU.COMBO_GROUPS' | translate }}
      </div>
      <div>
        <mat-accordion>
          <app-edit-combo-group
            *ngFor="let comboGroupStructure of sortComboGroups(data?.product.comboStructure.groups); let i = index"
            [currency]="currency"
            [comboGroupStructure]="comboGroupStructure"
            [originalComboGroupStructure]="getOriginalComboGroupStructure(i)"
            [dictionaryComboGroups]="dictionaryComboGroups"
            [originalDictionaryComboGroups]="originalDictionaryComboGroups"
            [dictionaryProducts]="dictionaryProducts"
            [dictionarySizes]="dictionarySizes"
            [originalDictionaryProducts]="originalDictionaryProducts"
            [overridePositionsMap]="overridePositionsMap"
            [currentOrganization]="data.organization"
            [menuSections]="data.menuSections"
            [menuSectionId]="data.menuSectionId"
            [productId]="data.product.externalId"
            [saveForMenuSections]="getSavedMenuSections()"
            (changeInformationMessageEvent)="onChangeInformationMessage($event)"
            [saveForAllCombo]="this.saveForAllCombo"
            [saveForAllProductsInComboGroup]="this.saveForAllProductsInComboGroup"
            [allowOverrides]="data.allowOverrides"
          ></app-edit-combo-group>
        </mat-accordion>
      </div>
    </div>

    <div *ngIf="data.allowOverrides" class="save-params">
      <div>
        <app-changes-for-menus
          [changesInformationMessage]="changesInformationMessage"
          [menuSections]="this.data.menuSections"
          [currentMenuSectionId]="this.data.menuSectionId"
          (menusSelected)="onMenuSelectedChanges($event)">
        </app-changes-for-menus>
      </div>
      <div>
        <mat-checkbox [checked]="saveForAllCombo" (change)="changeSaveForAllCombo($event.checked)">
          <label>For all combo</label>
        </mat-checkbox>
        <br>
        <mat-checkbox type="saveForAll" (change)="changeSaveForAll($event.checked)">
          <label>For all</label>
        </mat-checkbox>
        <br>
        <mat-checkbox *ngIf="data.product.comboStructure" [checked]="saveForAllProductsInComboGroup"
                      (change)="changeSaveForAllProductInComboGroup($event.checked)">
          <label>For all products in combo group</label>
        </mat-checkbox>
      </div>
    </div>

    <div class="form-bottom">
      <button
        *ngIf="data.allowOverrides"
        class="submit"
        mat-button
        [disabled]="disableSubmit || form.invalid || !form.touched || isBeingSaveProcessed"
      >{{ 'MENU.SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
